import { render, staticRenderFns } from "./MyFoot.vue?vue&type=template&id=05a8a0d3&scoped=true&"
import script from "./MyFoot.vue?vue&type=script&lang=js&"
export * from "./MyFoot.vue?vue&type=script&lang=js&"
import style0 from "./MyFoot.vue?vue&type=style&index=0&id=05a8a0d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a8a0d3",
  null
  
)

export default component.exports